/**
 * DevExtreme (esm/ui/data_grid/ui.data_grid.core.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _extends from "@babel/runtime/helpers/esm/extends";
import gridCoreUtils from "../grid_core/ui.grid_core.utils";
import modules from "../grid_core/ui.grid_core.modules";
export default _extends({}, modules, gridCoreUtils, {
    modules: []
});
